import * as React from 'react';
import { Card, Spinner } from "react-bootstrap";
import './PaymentHistory.css';
import { PaymentHistoryItemProps } from "./PaymentHistoryItem";
import { PaymentHistoryList } from "./PaymentHistoryList";

export interface PaymentHistoryProps {
    paymentHistory: PaymentHistoryItemProps[];
    moreCollectionsAvailable: boolean;
    emitHandleViewOlder;
    loading?: false
    emitHandleScheduleSpecialDebit;
    emitHandleRetryPayment;
}


export class PaymentHistory extends React.Component<PaymentHistoryProps> {
    constructor(props: PaymentHistoryProps) {
        super(props);
        this.handleViewOlder = this.handleViewOlder.bind(this);
        this.handleScheduleSpecialDebit = this.handleScheduleSpecialDebit.bind(this);
        this.handleRetryPayment = this.handleRetryPayment.bind(this);
    }
    
    handleViewOlder(e: any) {
        this.props.emitHandleViewOlder();
    }
    
    async handleScheduleSpecialDebit(e: any) {
        this.props.emitHandleScheduleSpecialDebit(e);
    }

    async handleRetryPayment(e: any) {
        this.props.emitHandleRetryPayment(e);
    }
    
    public render() {
        return (
            <div id="PaymentDeetsCard" className="payment-history">
                <Card>
                    <Card.Header className="payment-history__header p-3 br align-self-center">
                        <p className="m-0 ml-2 font-weight-bold">Payment history</p>
                    </Card.Header>
                    <Card.Body id="payment-history__card-body">
                        {(!this.props.loading && <PaymentHistoryList emitHandleRetryPayment={this.handleRetryPayment} emitHandleScheduleSpecialDebit={this.handleScheduleSpecialDebit} paymentHistory={this.props.paymentHistory}/>)
                        ||
                        <Spinner className="d-block mx-auto mb-2" animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner> }
                    </Card.Body>
                    { this.props.paymentHistory?.length > 0 && this.props.moreCollectionsAvailable &&
                    <Card.Footer>
                        <button className={`btn btn-outline-red payment-history__button ${!this.props.moreCollectionsAvailable ? 'disabled' : ''}`} onClick={this.handleViewOlder}>View older</button> 
                    </Card.Footer> }
                </Card>
            </div>
        )
    }
}
